import { render, staticRenderFns } from "./BaseLimitManagement.vue?vue&type=template&id=ceb729aa&scoped=true&"
import script from "./BaseLimitManagement.vue?vue&type=script&lang=js&"
export * from "./BaseLimitManagement.vue?vue&type=script&lang=js&"
import style0 from "./BaseLimitManagement.vue?vue&type=style&index=0&id=ceb729aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb729aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VCol,VContainer,VListItem,VListItemContent,VRow,VVirtualScroll})
